export * as Api from './api';
export var KycProcessStatus;
(function (KycProcessStatus) {
    KycProcessStatus["InProgress"] = "IN_PROGRESS";
    KycProcessStatus["Processing"] = "PROCESSING";
    KycProcessStatus["Reset"] = "RESET";
    KycProcessStatus["Failed"] = "FAILED";
    KycProcessStatus["Passed"] = "PASSED";
    KycProcessStatus["ManuallyApproved"] = "MANUALLY_APPROVED";
    KycProcessStatus["AdminApproved"] = "ADMIN_APPROVED";
    KycProcessStatus["NotAttempted"] = "NOT_ATTEMPTED";
})(KycProcessStatus || (KycProcessStatus = {}));
export var KycRiskRating;
(function (KycRiskRating) {
    KycRiskRating["Low"] = "LOW";
    KycRiskRating["Medium"] = "MEDIUM";
    KycRiskRating["MediumOrHigh"] = "MEDIUM_OR_HIGH";
    KycRiskRating["High"] = "HIGH";
})(KycRiskRating || (KycRiskRating = {}));
export var AmlResultsArchiveStatus;
(function (AmlResultsArchiveStatus) {
    AmlResultsArchiveStatus["NotArchived"] = "NOT_ARCHIVED";
    AmlResultsArchiveStatus["Archived"] = "ARCHIVED";
    AmlResultsArchiveStatus["All"] = "ALL";
})(AmlResultsArchiveStatus || (AmlResultsArchiveStatus = {}));
//# sourceMappingURL=index.js.map